import {routes} from '../src/routes/routes';

function App() {
    /*if(window.localStorage.getItem("divorce_id") === "undefined" || localStorage.getItem("divorce_id") === null){
      window.localStorage.clear();  
    }*/
  return(routes);
}

export default App;
